import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {MessageService} from '@app/app/shared/services/message.service';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './search-form.html',
  selector: 'search-form'
})
export class SearchFormComponent implements OnDestroy {
  @Output() public submitForm: EventEmitter<any> = new EventEmitter<any>();
  private readonly sub: Subscription;

  public form: FormGroup = new FormGroup({
    search: new FormControl('', Validators.required),
  });

  constructor(private messageService: MessageService) {
    this.sub = this.messageService.getMessage().subscribe(msg => {
      if (typeof(msg.res) === 'string' && msg.res === 'clearAll') {
        this.form.reset();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public onSubmit(...args) {
    if (this.form.valid) {
      this.submitForm.emit(args);
    }
  }

  public onKey(...args) {
    const _this2 = this;

    if (args[0].search === '') {
      setTimeout(function () {
        _this2.submitForm.emit(args);
      }, 500);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/nav/search-form/search.form.ts